import { InfoChip } from '@/components/ui/InfoChip'
import type { SealedOrderDeliveryInfo } from '@/payment/types'

import {
  AddressBody,
  AddressChips,
  AddressEntranceDetail,
  AddressInner,
  AddressSectionContainer,
  AddressSectionHeading,
} from './styles'

interface AddressSectionProps {
  deliveryInfo: SealedOrderDeliveryInfo
}

export function AddressSection({ deliveryInfo }: AddressSectionProps) {
  const fullAddress = [deliveryInfo.addressRoad, deliveryInfo.addressDetail].filter(Boolean).join(' ')

  return (
    <AddressSectionContainer>
      <AddressSectionHeading>주소</AddressSectionHeading>
      <AddressInner>
        <AddressBody>{fullAddress}</AddressBody>
        {deliveryInfo.entranceDetail && <AddressEntranceDetail>{deliveryInfo.entranceDetail}</AddressEntranceDetail>}
        <AddressChips>
          {deliveryInfo.phoneCallAvailable && <InfoChip>전화 가능</InfoChip>}
          {deliveryInfo.intercomCallAvailable && <InfoChip>세대호출 가능</InfoChip>}
        </AddressChips>
      </AddressInner>
    </AddressSectionContainer>
  )
}
